import { mockBuilder } from '../utils/builderHelper.es.js';
import { SamplesCredits } from './SamplesCredits.es.js';

/** @module Mocks */ function aSamplesCredits() {
    return mockBuilder(new SamplesCredits()).withRemaining(100);
}

export { aSamplesCredits };
